class homePage {
   init() { 
      console.log('homepage init');

      // var ul = document.querySelector('.products-list');
      
      // Shuffle function using Fisher-Yates algorithm
      function shuffle(array) {
         for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
         }
         return array;
      }
      
      $('.product-flip').each(function(){
         var itemsArray = $(this).children().get();
         var shuffledItems = shuffle(itemsArray);

         // limit to 10
         shuffledItems = shuffledItems.slice(0, 10);
     
         // remove all
         $(this).empty();

         const par = this;
         // Re-append shuffled items to the list
         shuffledItems.forEach(function(item, idx) {
            setTimeout(function(){
               par.appendChild(item);

               // check if images loaded, then show
               $(item).find('img').on('load', function(){
                  $(this).closest('.collection-card').addClass('loaded');
               }).each(function(){
                  if(this.complete) $(this).trigger('load');
               });
            }, idx * 50);
         });
      });

      $('.home-block .cls').on('click', function(e){
         e.stopPropagation();
         e.preventDefault();
         let tar = $(this).closest('.home-block');
         tar.toggleClass('out');
         if(tar.hasClass('out')) {
            $(this).text('ⓘ');
            localStorage.setItem('wwwcontemp-info-closed', 'true');
         } else {
            $(this).text('✕');
            localStorage.setItem('wwwcontemp-info-closed', 'false');
         }
      });

      if(localStorage.getItem('wwwcontemp-info-closed')) {
         if(localStorage.getItem('wwwcontemp-info-closed')=='true'){
            $('.home-block').addClass('out');
            $('.home-block .cls').text('ⓘ');
         } else if(localStorage.getItem('wwwcontemp-info-closed')=='false') {
            setTimeout(function(){
               $('.home-block').removeClass('out');
               $('.home-block .cls').text('✕');
            }, 1000);
         }
      }

      // $('.home-block').on('click', function(e){
      //    e.stopPropagation();
      //    e.preventDefault();
      //    if($(this).hasClass('out')) {
      //       $(this).removeClass('out');
      //       $(this).find('.cls').text('✕');
      //    }
      // });
         
         $('section[id*=featured_collection]').each(function(){
            let l = Math.random()*5 + 5;
            let r = Math.random()*5 + 5;
            let t = Math.random()*10 + 2;
            let b = Math.random()*8 - 4;
            // if(isTouch) {
            //    b = ;
            // }
            $(this).css('margin', `${t}rem ${r}% ${b}rem ${l}%`);
            
            setTimeout(() => {
               
               this.$items = $(this).find('.flip__item');
               this.itemCount = this.$items.length;
               this.currentIndex = 0;
               
               this.$items.each((i, el) => {
                  $(el).css({
                     transform: `rotate(${Math.random()*10-5}deg)`,
                     top: `${Math.random()*1 - .5}rem`,
                     left: `${Math.random()*1 - .5}rem`,
                     zIndex: i
                  });
                  
                  if (i == 0) {
                     $(el).addClass('act');
                  }
               });
               
               const par = this;
               
               // Clear any existing intervals
               if (par.loop) {
                  clearInterval(par.loop);
               }

               function parloop(par) {
                  par.currentIndex = (par.currentIndex + 1) % par.itemCount;
                  par.$items.each(function(index) {
                     let newIndex = (par.currentIndex + index) % par.itemCount;
                     let opMinus = newIndex / par.itemCount;
                     let opVal = 1 - (opMinus * 3.33);
                     $(this).css({
                        zIndex: par.itemCount - newIndex,
                        opacity: Math.max(0, opVal),
                     });
                     if (newIndex === 0) {
                        $(this).addClass('act');
                     } else {
                        $(this).removeClass('act');
                     }
                  });
               }
               
               // if(!$('html').hasClass('ios')) {
               par.loop = setInterval(() => {
                  parloop(par);
               }, 1800 + Math.random()*400); // Adjusted interval to a consistent 2000ms

               parloop(par);
               
               $(par).css('opacity', 1);
               
            }, 600); // 500ms because of the delay of shuffle
      });
         
      
      $(window).on('pageshow', function(){
         // $('.collection').addClass('in');
      });

      if(!isTouch) {
         $('.collection-flip').draggable({
         });
      }
   }
 }
 
 export default homePage;
 